import { generateUuid } from '@ftr/contracts/type/shared'
import { AbstractBuilder } from '@ftr/foundation'
import { LocalDateTime } from '@js-joda/core'
import { RealTimeSttTranscriptDivider } from '../lib/smart/real-time-stt/shared'

export class RealTimeSttTranscriptDividerBuilder extends AbstractBuilder<RealTimeSttTranscriptDivider> {
  static defaultTime = LocalDateTime.parse('2020-09-02T11:00')
  constructor() {
    super({
      type: 'Divider',
      dividerType: 'sessionStart',
      startTime: RealTimeSttTranscriptDividerBuilder.defaultTime,
      endTime: RealTimeSttTranscriptDividerBuilder.defaultTime,
      id: generateUuid(),
      sessionNumber: 1,
    })
  }

  atTime(time: LocalDateTime): RealTimeSttTranscriptDividerBuilder {
    return this.with({
      startTime: time,
      endTime: time,
    })
  }
}
